export interface Testimonial {
  quote: string;
  author: string;
  role: string;
  location: string;
}

// Single, high-impact testimonial shown right before the pricing section.
export const heroTestimonial: Testimonial = {
  quote:
    'Compré el manual un domingo por la noche desesperado por la clase del lunes. Sesión montada en 2 minutos. Mis alumnos notaron la diferencia al instante y yo recuperé mi tiempo libre.',
  author: 'Carlos M.',
  role: 'Monitor en club',
  location: 'Madrid'
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'Compré el manual un domingo por la noche desesperado por la clase del lunes. Increíble: abres el PDF, eliges la ficha y tienes la sesión montada en 2 minutos. El mejor dinero invertido este año.',
    author: 'Carlos M.',
    role: 'Monitor en club',
    location: 'Madrid'
  },
  {
    quote:
      'Lo que más me ha flipado es el Semáforo de Errores. Antes me costaba explicar por qué fallaban la bandeja. Ahora uso las consignas y los alumnos lo pillan a la primera. Me ven mucho más profesional.',
    author: 'Raquel F.',
    role: 'Entrenadora Nivel 1',
    location: 'Barcelona'
  },
  {
    quote:
      'Llevaba dos temporadas dando clases sin saber si lo estaba haciendo bien. Con este manual por primera vez siento que hay un hilo conductor real en mis sesiones.',
    author: 'Sergio B.',
    role: 'Monitor',
    location: 'Valencia'
  },
  {
    quote:
      'El Semáforo de Correcciones solo ya vale lo que cuesta el manual entero. Corrijo en una frase lo que antes me llevaba cinco minutos explicar.',
    author: 'Pablo C.',
    role: 'Monitor',
    location: 'Murcia'
  },
  {
    quote:
      'Al principio me pareció demasiado barato para ser bueno. Me equivoqué totalmente. La calidad del contenido está muy por encima del precio.',
    author: 'Iñaki A.',
    role: 'Monitor de club',
    location: 'Bilbao'
  }
];
